import { AbstractLocaleMessageObject } from "@/i18n/AbstractLocaleMessageObject"

import { IKeywordCategoryList } from "%%/labels/interfaces"

export class KeywordCategoryListEn extends AbstractLocaleMessageObject implements IKeywordCategoryList {
  readonly category = "Category"
  readonly description = "Description"
  readonly categoryFilterPlaceholder = "Filter by category name and description."
}
